module.exports = __webpack_public_path__ + "static/img/fail-bg.027efe10.png";